/* Fyndmaxa: storleksväljaren i produktkorten på mobil (2026-09-12).

   Markup i snippets/card-product.liquid (.fm-size-wrap), CSS i
   assets/fyndmaxa-card.css. Knappen .fm-size-toggle fäller ut storleksraden
   som en lista; varje rad får saldot i parentes från data-qty på
   <option>-elementen i kortets dolda <select name="id">. Saldot räknas för
   den variant som matchar vald färg + storleken på raden, alltså den som
   faktiskt läggs i varukorgen.

   Lyssnarna sitter på document: facets.js byter ut hela rutnätet vid
   filtrering, och skriptet laddas en gång per sida (defer) oavsett hur många
   sektioner som renderar kort. */
(function () {
  if (window.__fmSizeInit) return;
  window.__fmSizeInit = true;
  var KEYS = ['option1', 'option2', 'option3'];

  function refresh(wrap) {
    var form = wrap.closest('form');
    var sel = form && form.querySelector('select[name=id]');
    if (!sel) return;
    var checked = {};
    form.querySelectorAll('input[type=radio]:checked').forEach(function (r) { checked[r.dataset.position] = r.value; });
    wrap.querySelectorAll('.card-variants--size label').forEach(function (lab) {
      var r = lab.querySelector('input[type=radio]');
      var q = lab.querySelector('[data-fm-size-qty]');
      if (!r || !q) return;
      var want = {};
      KEYS.forEach(function (k) { want[k] = checked[k]; });
      want[r.dataset.position] = r.value;
      var opt = Array.prototype.find.call(sel.options, function (o) {
        return KEYS.every(function (k) { return !want[k] || o.dataset[k] === want[k]; });
      });
      var qty = opt && opt.dataset.qty ? opt.dataset.qty : null;
      var qtyText = qty === null ? '' : '(' + qty + ')';
      if (q.textContent !== qtyText) q.textContent = qtyText; // oförändrad text ger ingen mutation (observern nedan)
      lab.classList.toggle('is-selected', r.checked);
      // 2026-11-02: storlek som saknas i vald färg (ingen variant, eller slutsåld) gråas ut och kan inte väljas.
      var gone = !opt || opt.dataset.available === 'false';
      lab.classList.toggle('is-unavailable', gone);
      r.disabled = gone;
    });
    // Står valet på en storlek som försvann med färgbytet: hoppa till första storlek som finns.
    var curR = wrap.querySelector('.card-variants--size input[type=radio]:checked');
    if (curR && curR.disabled) {
      var firstOk = wrap.querySelector('.card-variants--size input[type=radio]:not(:disabled)');
      if (firstOk) { firstOk.checked = true; firstOk.dispatchEvent(new Event('change', { bubbles: true })); return; }
    }
    // Motsatt håll (2026-11-02): färgprickar som saknar vald storlek gråas. De går
    // fortfarande att klicka – då hoppar storleken till första som finns i färgen.
    var card = wrap.closest('.card-wrapper');
    if (card) {
      var checkedNow = {};
      form.querySelectorAll('input[type=radio]:checked').forEach(function (r) { checkedNow[r.dataset.position] = r.value; });
      card.querySelectorAll('.card-variants--color label').forEach(function (clab) {
        var cr = clab.querySelector('input[type=radio]');
        if (!cr) return;
        var wantC = {};
        KEYS.forEach(function (k) { wantC[k] = checkedNow[k]; });
        wantC[cr.dataset.position] = cr.value;
        var okC = Array.prototype.some.call(sel.options, function (o) {
          return o.dataset.available !== 'false' && KEYS.every(function (k) { return !wantC[k] || o.dataset[k] === wantC[k]; });
        });
        clab.classList.toggle('is-unavailable', !okC);
      });
    }
    var lbl = wrap.querySelector('[data-fm-size-label]');
    var cur = wrap.querySelector('.card-variants--size input[type=radio]:checked');
    if (lbl && cur) lbl.textContent = lbl.dataset.name + ': ' + cur.value.split('-').pop().trim();
  }

  function close(w) {
    w.classList.remove('is-open');
    var b = w.querySelector('.fm-size-toggle');
    if (b) b.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    document.querySelectorAll('.fm-size-wrap.is-open').forEach(function (w) { if (w !== except) close(w); });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var t = e.target.closest('.fm-size-toggle');
    if (t) {
      e.preventDefault();
      var w = t.closest('.fm-size-wrap');
      var open = !w.classList.contains('is-open');
      closeAll(w);
      if (open) { refresh(w); w.classList.add('is-open'); t.setAttribute('aria-expanded', 'true'); }
      else { close(w); }
      return;
    }
    if (!e.target.closest('.fm-size-wrap')) closeAll();
  });

  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || !r.matches || !r.matches('.card-wrapper input[type=radio]')) return;
    var card = r.closest('.card-wrapper');
    card.querySelectorAll('.fm-size-wrap').forEach(refresh);
    var w = r.closest('.fm-size-wrap');
    if (w) close(w);
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  // Vid sidladdning (och när facets.js byter ut rutnätet): sätt gråning direkt, inte först när listan öppnas.
  function refreshAll() { document.querySelectorAll('.fm-size-wrap').forEach(refresh); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshAll); else refreshAll();
  // Bara när nya kort kommer in (t.ex. facets.js), aldrig på ändringar inuti väljaren själv – annars loop.
  new MutationObserver(function (m) {
    var fresh = m.some(function (x) {
      if (!x.addedNodes.length || (x.target.closest && x.target.closest('.fm-size-wrap'))) return false;
      return Array.prototype.some.call(x.addedNodes, function (n) { return n.nodeType === 1 && (n.matches('.card-wrapper') || n.querySelector('.fm-size-wrap')); });
    });
    if (fresh) refreshAll();
  }).observe(document.body, { childList: true, subtree: true });
})();
